import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { SELECT_CLEAR } from '@/components/ui/select-sentinels'
import { FilterOperators } from '../../Reports/reports.constants'
import { setCloudReportFilters } from '../../Reports/reports.slice'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCloudReportFilters } from '../../Reports/reports.selectors'

const BooleanHeaderFilter = ({ column }) => {
	const dispatch = useDispatch()
	const reportFilters = useSelector(selectCloudReportFilters)

	const current = reportFilters[`${column.dataField}`]
	const currentValue = current?.filterOperationType === FilterOperators.Equal
		? (current?.filterValue === true ? 'true' : current?.filterValue === false ? 'false' : '')
		: current?.filterOperationType === FilterOperators.IsEmpty
		? 'empty'
		: ''

	return (
		<Select
			value={currentValue}
			onValueChange={(val) => {
				if (val === 'true') {
					dispatch(setCloudReportFilters({
						...reportFilters,
						[`${column.dataField}`]: { filterOperationType: FilterOperators.Equal, filterValue: true },
					}))
				} else if (val === 'false') {
					dispatch(setCloudReportFilters({
						...reportFilters,
						[`${column.dataField}`]: { filterOperationType: FilterOperators.Equal, filterValue: false },
					}))
				} else if (val === 'empty') {
					dispatch(setCloudReportFilters({
						...reportFilters,
						[`${column.dataField}`]: { filterOperationType: FilterOperators.IsEmpty },
					}))
				} else if (val === SELECT_CLEAR) {
					dispatch(setCloudReportFilters({ ...reportFilters, [`${column.dataField}`]: null }))
				}
			}}
		>
			<SelectTrigger className='w-28'>
				<SelectValue placeholder='—' />
			</SelectTrigger>
			<SelectContent>
				<SelectItem value='true'>Yes</SelectItem>
				<SelectItem value='false'>No</SelectItem>
				{column.allowsEmpty && <SelectItem value='empty'>Empty</SelectItem>}
				<SelectItem value={SELECT_CLEAR}>Clear</SelectItem>
			</SelectContent>
		</Select>
	)
}

export default BooleanHeaderFilter
